"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrB2bLoginLayout = void 0;
const react_1 = __importDefault(require("react"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const fdr_b2b_login_styles_1 = require("./fdr-b2b-login.styles");
function FdrB2bLoginLayout({ mainTitle, mainText, loading, children, }) {
    return (react_1.default.createElement(fdr_b2b_login_styles_1.FdrLayoutWrapper, null,
        react_1.default.createElement(fdr_b2b_login_styles_1.FdrLayoutBlockWrapper, null,
            react_1.default.createElement(fdr_b2b_login_styles_1.FdrLayoutBlock, null,
                loading ? (react_1.default.createElement("div", { className: "text-line-skeleton-wrapper", "data-id": "text-skeleton-wrap" },
                    react_1.default.createElement(FdrTextLineSkeleton, { width: 250 }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("h2", { className: "form-title" }, mainTitle),
                    mainText && (react_1.default.createElement("div", { className: "form-text", "data-id": "layout-text", dangerouslySetInnerHTML: {
                            __html: mainText,
                        } })))),
                children))));
}
exports.FdrB2bLoginLayout = FdrB2bLoginLayout;
// TODO: add to bit.dev as a separate module ?
function FdrTextLineSkeleton({ width }) {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    return (react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { uid: `TextLineSkeleton_${width}`, width: width, height: mobile ? 18 : 25, speed: 2, style: { width: `${width}px`, height: '18px' } },
        react_1.default.createElement("rect", { width: width, height: mobile ? 18 : 25, rx: 8 })));
}
//# sourceMappingURL=fdr-b2b-login-layout.js.map